import React from 'react';
import './LocalGameIcon.css';
import {WAR_COLOR} from '../../../styles/constants';

const LOCAL_GAME_ICON_PATH = '/img/icons/local_game.png';

/**
 * Иконка локального матча в истории матчей. Завершенная партия — обычная
 * картинка, незавершенная — красная маска того же значка: в истории ее видно
 * сразу, не вчитываясь в подписи (как и недоигранное обучение — см.
 * TutorialBookIcon)
 */
export function LocalGameIcon({isUnfinished = false, className = ''}) {
  const label = isUnfinished ? 'Локальная игра не завершена' : 'Локальная игра';

  if (!isUnfinished) {
    return (
      <img
        className={className}
        src={LOCAL_GAME_ICON_PATH}
        alt={label}
        title={label}
      />
    );
  }

  return (
    <span
      className={`local-game-icon local-game-icon_unfinished ${className}`}
      style={{
        backgroundColor: WAR_COLOR,
        WebkitMaskImage: `url("${LOCAL_GAME_ICON_PATH}")`,
        maskImage: `url("${LOCAL_GAME_ICON_PATH}")`,
      }}
      role={'img'}
      aria-label={label}
      title={label}
    />
  );
}
